import type { HTMLAttributes } from 'react';

import { cn } from '../../lib/utils.js';

export type SpinnerProps = HTMLAttributes<HTMLSpanElement>;

export function Spinner({ className, ...props }: SpinnerProps) {
  return (
    <span className={cn('spinner', className)} role="status" aria-label="Loading" {...props} />
  );
}
